import { render, staticRenderFns } from "./GrossProfit.vue?vue&type=template&id=a8d8a068&scoped=true"
import script from "./GrossProfit.vue?vue&type=script&lang=js"
export * from "./GrossProfit.vue?vue&type=script&lang=js"
import style0 from "./GrossProfit.vue?vue&type=style&index=0&id=a8d8a068&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d8a068",
  null
  
)

export default component.exports